import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LiveSessionService } from '@/services/liveSession.service';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import type { LiveSession } from '@/types';

export function LiveFeedPage() {
    const [sessions, setSessions] = useState<LiveSession[]>([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        LiveSessionService.getActiveSessions()
            .then(setSessions)
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <LoadingSpinner fullScreen />;

    return (
        <div className="container py-4">
            <h1 className="mb-4">Live Sessions</h1>

            {sessions.length === 0 ? (
                <div className="text-center py-5">
                    <div className="display-1 text-muted mb-3"><i className="bi bi-broadcast"></i></div>
                    <h3>No Active Sessions</h3>
                    <p className="text-muted">Start a session from your playlists to see it here!</p>
                    <button className="btn btn-primary" onClick={() => navigate('/playlists')}>
                        Browse Playlists
                    </button>
                </div>
            ) : (
                <div className="row g-4">
                    {sessions.map(session => (
                        <div key={session.id} className="col-md-6 col-lg-4">
                            <div className="card h-100 shadow-sm">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                        <h5 className="card-title text-truncate" title={session.metadata?.playlistName}>
                                            {session.metadata?.playlistName || 'Untitled Session'}
                                        </h5>
                                        <span className="badge bg-danger animate-pulse">LIVE</span>
                                    </div>
                                    <p className="card-text text-muted small">
                                        <i className="bi bi-music-note-list me-1"></i> {session.metadata?.totalTracks || 0} Tracks
                                        <span className="mx-2">•</span>
                                        <i className="bi bi-people me-1"></i> {session.connectedUsers.length} Listening
                                    </p>
                                    <button
                                        className="btn btn-outline-danger w-100"
                                        onClick={() => navigate(`/playlists/${session.playlistId}/live`)}
                                    >
                                        Join Now
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
